import React, { useEffect, useState } from 'react';

import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';

import FloatingButton from '../../../../components/FloatingButton';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { VEHICLE_UBICATIONS } from '../../../../constants/assistance.constant';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';

const VehicleUbication = () => {
  const { nextStep, assistance_body, updateAssistanceBody } =
    useAssistanceDataContext();
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);
  const [moved, setMoved] = useState(false);
  const { user } = useAuthDataContext();

  const CallNextStep = () => {
    dataLayerPush('opcion_asistencia_ubicaciónEspecífica', user?.id, {
      fieldName: 'opcion_asistencia_ubicaciónEspecífica',
      fieldValue: assistance_body.vehicle_location,
    });
    nextStep();
  };

  useEffect(() => {
    if (assistance_body.vehicle_location) {
      setValue(assistance_body.vehicle_location);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const vehicle_location = (event.target as HTMLInputElement).value;
    setValue(vehicle_location);
    updateAssistanceBody({
      vehicle_location,
    });

    if (vehicle_location === 'Autopista') {
      setOpen(true);
      setMoved(false);
    } else {
      setMoved(true);
    }
  };

  return (
    <>
      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Typography variant="h6">
              Necesitamos que te encuentres en un espacio apto para grúas
              privadas
            </Typography>
            <Box my={2}>
              <Typography>
                Comunicate previamente con la asistencia de la autopista así
                podemos ir a buscarte
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    setMoved(false);
                    setOpen(false);
                  }}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    setOpen(false);
                    setMoved(true);
                  }}
                >
                  Ya movieron mi vehículo
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>
      <Grid container>
        <Grid item xs={12}>
          <Box my={4}>
            <Typography variant="h6">
              ¿Dónde se encuentra el vehículo?
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box my={4}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="vehicle-ubication"
                name="vehicle-ubication"
                value={value}
                onChange={handleChange}
              >
                {VEHICLE_UBICATIONS.map((ubication: any) => (
                  <FormControlLabel
                    key={ubication.value}
                    value={ubication.value}
                    control={<Radio color="primary" />}
                    label={ubication.label}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FloatingButton
            onClick={() => CallNextStep()}
            disabled={!value || !moved}
          >
            Continuar
          </FloatingButton>
        </Grid>
      </Grid>
    </>
  );
};

export default VehicleUbication;
